<div [style.min-height]="bottomEdge + 'px'">
  <ng-content #content></ng-content>
  <div class="bottomEdge"></div>
</div>
